import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseApiUrl = 'api/v1/sales';
const overviewBaseUrl = 'api/v1/dashboard/product-keys';

interface IChartServiceParam {
  startDate: string;
  endDate: string;
  period: string;
  companyId: number;
  shopId: number;
}

export default class ChartDataService {
  public retrieve(param: IChartServiceParam): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${this.buildSearchQueryOpts(param)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public overview(searchQuery?: any, paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(overviewBaseUrl + `/overview?${searchQuery}&${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  private buildSearchQueryOpts(param: IChartServiceParam): string {
    const { startDate, endDate, period, companyId, shopId } = param;
    let queryString = '';
    if (startDate && endDate) {
      queryString = `startDate=${startDate}&endDate=${endDate}&period=${period}&companyId=${companyId}`;
      if (shopId) {
        queryString += `&shopId=${shopId}`;
      }
    }
    return queryString;
  }
}
